module.exports = __webpack_public_path__ + "img/chr_ts_90_21_3.593460fa.png";